import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  CanActivate,
  CanActivateChild,
  Router
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { map, catchError, take, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.checkAuth(state.url);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.checkAuth(state.url);
  }

  private checkAuth(url: string): Observable<boolean | UrlTree> {
    return this.auth.isAuthenticated$.pipe(
      take(1), // Only take first emission to prevent multiple redirects
      switchMap(loggedIn => {
        if (loggedIn) {
          return of(true);
        }
        // Not logged in - store the attempted URL for redirecting after login
        console.warn('AuthGuard: User not authenticated, redirecting to home');
        return of(this.router.parseUrl('/home'));
      }),
      catchError(err => {
        console.error('AuthGuard: Error checking authentication', err);
        return of(this.router.parseUrl('/home'));
      })
    );
  }
}
